import SubscriptionFeeUseCase from "@domains/useCases/Reports/Subscription/SubscriptionFee";
import EmailReport from "@domains/useCases/Reports/common/emailReport/emailReport";
import DownloadPDFReport from "@domains/useCases/Reports/common/downloadReport/downloadPdfReport";
import DownloadExcelReport from "@domains/useCases/Reports/common/downloadReport/downloadExcelReport";
import SubscriptionPopupUseCase from "@domains/useCases/Reports/Subscription/SubscriptionPopup";
import SubscriptionPopupEmailUseCase from '@domains/useCases/Reports/Subscription/SubsciptionPopupEmail';
export default (repositories) => {
    return {
        subscriptionFee: new SubscriptionFeeUseCase(repositories.subscriptionReport),
        subscriptionPopup: new SubscriptionPopupUseCase(repositories.subscriptionReport),
        subscriptionPopupEmail: new SubscriptionPopupEmailUseCase(repositories.subscriptionReport),
        sendEmailReports: new EmailReport(repositories.downloadRepo),
        downloadPDFReports: new DownloadPDFReport(repositories.downloadRepo),
        downloadExcelReports: new DownloadExcelReport(repositories.downloadRepo),
    };
};
